<div class="tm">
  <!-- What will go out, and to how many -->
  <section class="bk-panel tm__facts" aria-labelledby="tm-title">
    <header class="tm__head">
      <h2 class="bk-heading tm__title" id="tm-title">Preview and test</h2>
    </header>

    <dl class="bk-kv tm__kv">
      <dt>Sender ID</dt>
      <dd>{{ messagesService.messages.senderId || "Not chosen yet" }}</dd>

      <dt>Subject</dt>
      <dd>{{ messagesService.messages.subject || "No subject" }}</dd>

      <dt>Recipients</dt>
      <dd>
        @if (isFetchingCount) {
          <span class="bk-skel tm__skel" aria-label="Counting recipients"></span>
        } @else if (audience.failed) {
          <span class="tm__muted">Couldn’t count them. Check your connection.</span>
        } @else {
          {{ formatCount(recipientCount) }} unique
          {{ recipientCount === 1 ? "person" : "people" }}
        }
      </dd>

      <dt>Cost per send</dt>
      <dd>
        @if (units !== null) {
          {{ parts.estimated ? "About " : "" }}{{ formatCount(units) }} SMS
          <span class="tm__muted">
            ({{ parts.parts }} {{ parts.parts === 1 ? "part" : "parts" }} × {{ formatCount(recipientCount) }})
          </span>
        } @else {
          <span class="tm__muted">Shown once the audience is counted</span>
        }
      </dd>

      <dt>Messages in campaign</dt>
      <dd>{{ totalMessages }}</dd>
    </dl>

    <div class="tm__actions">
      <button type="button" class="bk-btn bk-btn--ghost" (click)="backToMessages()">
        <span class="bk-sym" aria-hidden="true">arrow_back</span>
        Back to messages
      </button>
      <button type="button" class="bk-btn bk-btn--primary" (click)="selectTestUser = true">
        <span class="bk-sym" aria-hidden="true">send</span>
        Send a test
      </button>
    </div>
  </section>

  <!-- As a handset shows it -->
  <section class="bk-panel tm__phone" aria-label="Message as recipients see it">
    <!-- The sender ID keeps its case, as handsets show it -->
    <p class="tm__from">
      <span class="bk-eyebrow">From</span>
      <span class="tm__sender" [class.is-empty]="!messagesService.messages.senderId">
        {{ messagesService.messages.senderId || "your sender ID" }}
      </span>
    </p>
    @if (messagesService.messages.body) {
      <bk-sms-bubble [text]="messagesService.messages.body" />
    } @else {
      <p class="tm__muted">Write the message first, then preview it here.</p>
    }
  </section>
</div>

<!-- The shared test window: one or more test contacts, each sent separately -->
<app-send-test-message-modal
  [openModal]="selectTestUser"
  [messageBody]="messagesService.messages.body || ''"
  [senderId]="messagesService.messages.senderId || ''"
  (closeModalEvent)="selectTestUser = false"
/>
